const BREAK_POINTS = { "ltSP": 768, "ltTAB": 992, "gtPC": 992 }

export { BREAK_POINTS };
